/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MakeAppointmentExchangeOfferRequest
 */
export interface MakeAppointmentExchangeOfferRequest {
    /**
     * 
     * @type {string}
     * @memberof MakeAppointmentExchangeOfferRequest
     */
    offeredAppointmentId: string;
    /**
     * 
     * @type {string}
     * @memberof MakeAppointmentExchangeOfferRequest
     */
    note: string | null;
}

/**
 * Check if a given object implements the MakeAppointmentExchangeOfferRequest interface.
 */
export function instanceOfMakeAppointmentExchangeOfferRequest(value: object): value is MakeAppointmentExchangeOfferRequest {
    if (!('offeredAppointmentId' in value) || value['offeredAppointmentId'] === undefined) return false;
    if (!('note' in value) || value['note'] === undefined) return false;
    return true;
}

export function MakeAppointmentExchangeOfferRequestFromJSON(json: any): MakeAppointmentExchangeOfferRequest {
    return MakeAppointmentExchangeOfferRequestFromJSONTyped(json, false);
}

export function MakeAppointmentExchangeOfferRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MakeAppointmentExchangeOfferRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'offeredAppointmentId': json['offeredAppointmentId'],
        'note': json['note'],
    };
}

export function MakeAppointmentExchangeOfferRequestToJSON(json: any): MakeAppointmentExchangeOfferRequest {
    return MakeAppointmentExchangeOfferRequestToJSONTyped(json, false);
}

export function MakeAppointmentExchangeOfferRequestToJSONTyped(value?: MakeAppointmentExchangeOfferRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'offeredAppointmentId': value['offeredAppointmentId'],
        'note': value['note'],
    };
}

